<div *ngIf="isLoading()" class="loading-overlay">
    <div class="loader"></div>
</div>